export const formatLanguageFromLocalStorage = (language) => {
  let emailLanguage;

  if(language === "pt-BR") {
    emailLanguage = "pt"
  } else if(language === "esp-ES") {
    emailLanguage = "esp"
  } else if(language === "en-US") {
    emailLanguage = "en"
  }
  return emailLanguage;
}
